import React from 'react';
import { Badge } from 'reactstrap';

import { SahReferenceDataSync } from '~support-at-home/models/sahReferenceData';

// `renderReadOnly`-compatible mapper for the "Status" column. `last_status` is null until the
// list has ever been refreshed, which is a distinct (neutral) state from a refresh that ran and
// failed — hence three badge variants rather than a boolean success/failure toggle.
export const renderSyncStatusBadge = (value: SahReferenceDataSync['last_status']) => {
  if (!value) return <Badge color="secondary">Never run</Badge>;
  return <Badge color={value === 'success' ? 'success' : 'danger'}>{value === 'success' ? 'Success' : 'Error'}</Badge>;
};

// The "Message" mapper and the per-row "Actions" refresh button were removed (TAV-2589): the tab is
// read-only status reporting, not something a user acts on row by row. `last_message` is still
// written and still returned by GET /v2/sah/reference-data — it is simply not rendered, so a failed
// scheduled refresh now shows a red "Error" badge with the reason available only in the API response
// and the Lambda's CloudWatch logs.
